// Controller.jsx
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Spinner } from "@nextui-org/react";
import CustomNavbar from "../productnavbar";
import Footer from "../../footer/footer";
import RevealBlurFX from "../../../../components/Effect/RevealBlurFX";
import { BASEURL } from "../../../../constant/constant";
import "./ProductSubCategory.css";

function ProductSubCategory() {
  const navigate = useNavigate();
  const { slug } = useParams();
   const { state } = useLocation();
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);
  const categoryName = state?.categoryName || "";

  const fetchSubcategories = async (slug) => {
    try {
      setLoading(true);
      setError(null);
      const subcatResponse = await fetch(
        `${BASEURL}/api/product/getSubcategory/${slug}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        }
      );
      if (!subcatResponse.ok) throw new Error(`HTTP ${subcatResponse.status}`);
      const data = await subcatResponse.json();

      if (data.subcategories && data.subcategories.length > 0) {
        setSubcategories(data.subcategories);
      } else {
        setError("No subcategories found.");
      }
    } catch (error) {
      setError("Failed to fetch subcategories. Please try again.");
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    if (slug) {
      fetchSubcategories(slug);
    }
    hasFetched.current = true;
  }, [slug]);


  return (
    <div className="products flex flex-col p-2">
      <Helmet>
        <title>Our Product Categories | SEA</title>
        <meta name="description" content="Explore our product categories" />
        <meta name="keywords" content="Explore our product categories" />
        <meta
          property="og:title"
          content="Explore Our Product Categories"
        />
        <meta property="og:url" content="https://seaiot.in/products" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* <CustomNavbar /> */}
      <div className="products-second-div">
        <div className="details-heading">
          <h1>{categoryName}</h1>
          {/* <p>
            Offering you a complete choice of products which include Submersible
            Solar Pump Controller and more.
          </p> */}
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-48">
            <Spinner color="warning" label="Loading..." />
          </div>
        ) : error ? (
          <div className="text-center text-red-500 font-semibold">
            {error}
          </div>
        ) : (
          <div className="grid grid-cols-12 p-2 m-2">
            {subcategories.map((sub) => (
              <div
                className="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-4  item-center"
                key={sub.sub_category_id}
              >
                <div
                  className="productcard"
                  onClick={() =>
                    navigate(
                      `/productdetails/${slug}/${sub.sub_category_slug}`
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  {sub.img_url ? (
                    <img
                      className="mt-20"
                      src={`${BASEURL}${sub.img_url}`}
                      alt={sub.sub_category_name}
                      style={{
                        filter:
                          "drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.5))",
                        borderRadius: "8px",
                        height: "350px",
                      }}
                    />
                  ) : (
                    <div className="h-56 flex justify-center items-center bg-gray-200">
                      <span>No Image Available</span>
                    </div>
                  )}
                  <div className="productcardtitle">
                    <h3>{sub.sub_category_name}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductSubCategory;
